import { render, staticRenderFns } from "./DetallePago.vue?vue&type=template&id=d72d6b32"
import script from "./DetallePago.vue?vue&type=script&lang=js"
export * from "./DetallePago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports